const colors = {
  white: "#FFFFFF",
  totallyBlack: "#000000",
  black: "#121212",
  darkGray: "#434343",
  darkBlue: "#134EBF",
  gray1: "#525252",
  gray2: "#D9D9D9",
  gray3: "#F3F3F3",
  gray4: "#EDEDED",
  disabled: "#AAAAAA",
  lightGray: "#F6F7F7",
  primaryGreen: "#06D0AC",
  lightGreen: "#E6FAF6",
};

export default colors;
